// src/customHooks/Services/useServices.js (Updated)

import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import usePermission from "../../utils/usePermission";

import { apiHandler } from "../../api";
import { saveStoreData } from "../../features/login/LoginSlice";

const PAGE_SIZE = 100;
const DEBOUNCE_DELAY = 300;
const MIN_SEARCH_LENGTH = 3;

export const useServices = (service = "RSF") => {
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const brandName =
    useSelector((state) => state.loginSlice.brandName) ||
    localStorage.getItem("brandName");

  // CORRECTED: Initialize stores as an empty object {}
  const [stores, setStores] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [initiallyHadData, setInitiallyHadData] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const debounceTimer = useRef(null);

  const canRead = usePermission("MULTI_STORES");

  // Wrapped fetchStores in useCallback and added dependencies
  const fetchStores = useCallback(
    async (searchQuery = "") => {
      try {
        setLoading(true);
        setError(null);

        const response = await apiHandler({
          url: `https://ondcidentitybackend.clouddeploy.in/api/v1/tenant/getServiceTenants?iPageSize=${PAGE_SIZE}&sSearchByName=${encodeURIComponent(
            searchQuery
          )}&sService=${encodeURIComponent(service)}`,
          method: "GET",
          authToken: authData,
          dispatch,
          storeId,
        });

        //console.log("Stores API response:", response);

        if (response?.data?.statusCode === 200) {
          // CORRECTED: storeList will now be the grouped object
          const groupedStoreData = response?.data?.data || {};

          setStores(groupedStoreData); // Set the grouped object
          setError(null);

          const totalRecords = response?.data?.totalRecords || 0;
          if (totalRecords > 0 && !initiallyHadData) {
            setInitiallyHadData(true);
          }
          setTotalCount(totalRecords);
        } else {
          setStores({});
          setError(response?.data?.message);
        }
      } catch (err) {
        setStores({});
        setError(err.message || "Failed to fetch stores");
      } finally {
        setLoading(false);
      }
    },
    [authData, dispatch, storeId, service, initiallyHadData]
  );

  const debouncedSearch = useCallback(
    (searchQuery) => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }

      if (searchQuery === "" || searchQuery.length >= MIN_SEARCH_LENGTH) {
        debounceTimer.current = setTimeout(() => {
          if (canRead) {
            fetchStores(searchQuery);
          }
        }, DEBOUNCE_DELAY);
      }
    },
    [canRead, fetchStores] // Dependency changed to fetchStores
  );

  useEffect(() => {
    fetchStores(search);
  }, [search, fetchStores]); // Dependency changed to fetchStores

  const handleStoreSearch = (e) => {
    const searchQuery = e.target.value;
    setSearch(searchQuery);
    debouncedSearch(searchQuery);
  };
  const handleChangeStore = (store) => {
    dispatch(
      saveStoreData({
        storeId: store.id,
        brandName: store.brand_name,
      })
    );
    navigate("/analytics", { replace: true });
  };
  return {
    stores, // Returns the grouped object
    setStores,
    loading,
    setLoading,
    error,
    totalCount,
    handleStoreSearch,
    initiallyHadData,
    search,
    authData,
    handleChangeStore,
  };
};